// MADE THIS FILE TO IMPORT FROM THIS FILE

import {
    EateryCard,
    UserCard,
    UserTransactionInfo,
    UserTransactionKind,
    UserWallet,
} from 'api'
import { cloneDefault } from 'shared'
import { createStore } from 'solid-js/store'

export type TransactionsCustom = {
    t: UserTransactionInfo
    e: EateryCard
    u: UserCard
}
type STATE = {
    loading: boolean
    transactions: TransactionsCustom[]

    charger: {
        type: keyof UserWallet | null
        amount: number
        loading: boolean
    }

    activeKind: UserTransactionKind['kind'] | null
}
const STATE_DEF: STATE = {
    loading: true,
    charger: {
        amount: 1,
        type: null,
        loading: false,
    },
    transactions: [],
    activeKind: null,
}
const [state, setState] = createStore<STATE>(cloneDefault(STATE_DEF))

export {
    state as accountWalletS,
    setState as setAccountWalletS,
    STATE_DEF as WALLET_STATE_DEF,
    type STATE as accountWalletStateType,
}
